var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowWithGreenBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9999,
    cy: 15.418,
    r: 15,
    transform: "rotate(-180 14.9999 15.418)",
    fill: "#178477"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7506 15.034C12.7506 15.034 16.6838 18.9672 16.9971 19.2805C17.3104 19.5938 17.3572 20.055 16.9971 20.4151C16.637 20.7752 16.1758 20.7285 15.8625 20.4151C15.5492 20.1018 11.0487 15.6014 11.0487 15.6014C10.7354 15.288 10.7354 14.7801 11.0487 14.4667L15.8625 9.65296C16.1758 9.33964 16.6838 9.33964 16.9971 9.65296C17.3104 9.96627 17.3104 10.4743 16.9971 10.7876L12.7506 15.034Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWithGreenBg);
export default __webpack_public_path__ + "static/media/arrow-with-green-bg.e07c03b457a402435bdcd2d607073923.svg";
export { ForwardRef as ReactComponent };